
const orgSysData = sessionStorage.getItem('orgsys')

const initialValue = orgSysData ? JSON.parse(orgSysData) : { systems: [], orgs: [] }

// Reducer contains state and action (type & data)
function staticData(state = { data: initialValue, initialized: false }, action) {
    switch (action.type) {
        case "staticData/set": {
            return {
                ...state,
                ...action.payload
            }
        }
        case "staticData/remove":{
			return{
				data: initialValue,
				initialized: false
			}
		}
        default: {
            return state
        }
    }
}

export default staticData
